import { Box } from "@mui/material";
import ShortTurnaroundCrewRoutes from 'components/ShortTurnaroundCrewRoutes';


export function CrewTATsCard({ data }) {
    
  return (
    <Box 
      id="shortTAT"
      component="section"
      height={450} 
      pr={0.5} 
      sx={{
        borderRadius: 1,
        border: "1px solid",
        borderColor: "neutral.deep",
        backgroundColor: "background.default",
      }}
    > 
      <ShortTurnaroundCrewRoutes crewRoutes={data}/>        
    </Box>
  );
}